<template>
<div class="bottom-wrap main clearfix">
	<div class="bottom-left left">
		<ul class="clearfix" v-if="roomTopLeftNormal">
  	  <li v-for="item of roomTopLeftNormal" :key="item.id" class="left">
  	 	  <nuxt-link class="ellipsis" :to="item.link" target="_blank" rel="noopener">{{ item.title }}</nuxt-link>
  	  </li>
		</ul>
	</div>
	<div v-if="roomBottomImageNormal" class="bottom-right left">
 	  <nuxt-link :to="roomBottomImageNormal[0].link" target="_blank" rel="noopener">
	    <img class="pic" :src="roomBottomImageNormal[0].image" :alt="roomBottomImageNormal[0].title" />
	  </nuxt-link>
	</div>
</div>
</template>

<script>
export default {
	name: 'component-room-eliteIntroduce',
	created () {
		this.$store.dispatch('getAd', ['roomBottomImageNormal', 'roomTopLeftNormal'])
	},
	computed: {
		roomTopLeftNormal () {
			return this.$store.state.adList['roomTopLeftNormal']
		},
		roomBottomImageNormal () {
			return this.$store.state.adList['roomBottomImageNormal']
		}
	}
}
</script>

<style lang="less" scoped>
.bottom-wrap { background: #fff; margin-top: 15px;
  .bottom-left { width: 760px; padding: 20px;
    ul {
      li {
        a {
					display: inline-block; color: #6b6b6b; font-size: 14px; width: 350px; line-height: 25px;
          &:hover { color: #e7735a;}
				}
				&:nth-child(n) {
					a {
						margin-right: 10px;
					}
				}
      }
    }
  }
  .bottom-right { width: 415px; height: 185px;
    a,img { display: block; width: inherit; height: inherit; }
  }
}
</style>
